import { ReactNode } from 'react';
import { CORE_ROUTER_CONFIG } from '../../core/config/router/router';
import { APP_ROUTER_CONFIG } from '../../app/config/router/router';

export type RouteConfig = {
  path: string;
  element?: ReactNode;
  navigate?: string;
};

export type RoutesConfig = {
  auth: RouteConfig[];
  authNonAuth: RouteConfig[];
  admin: RouteConfig[];
  adminNonAuth: RouteConfig[];
};

export const ROUTER_CONFIG: RoutesConfig = {
  auth: [...CORE_ROUTER_CONFIG.auth, ...APP_ROUTER_CONFIG.auth],
  authNonAuth: [
    ...CORE_ROUTER_CONFIG.authNonAuth,
    ...APP_ROUTER_CONFIG.authNonAuth,
  ],
  admin: [...CORE_ROUTER_CONFIG.admin, ...APP_ROUTER_CONFIG.admin],
  adminNonAuth: [
    ...CORE_ROUTER_CONFIG.adminNonAuth,
    ...APP_ROUTER_CONFIG.adminNonAuth,
  ],
};
